const API_URL = 'https://nd-tools-backend.vercel.app/api';

const getHeaders = () => {
    const token = sessionStorage.getItem('ndtools_token');
    return {
        'Content-Type': 'application/json',
        ...(token ? { Authorization: `Bearer ${token}` } : {})
    };
};

export const api = {
    // Auth
    login: async (email, password) => {
        const res = await fetch(`${API_URL}/auth/login`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ email, password })
        });
        if (!res.ok) throw new Error('Login failed');
        return res.json();
    },
    uploadImage: async (file) => {
        const formData = new FormData();
        formData.append('image', file);
        const res = await fetch(`${API_URL}/upload`, {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${sessionStorage.getItem('ndtools_token')}`
            },
            body: formData
        });
        return res.json();
    },

    // Products
    getProducts: async () => {
        const res = await fetch(`${API_URL}/products`);
        if (!res.ok) return [];
        return res.json();
    },
    addProduct: async (data) => {
        const res = await fetch(`${API_URL}/products`, {
            method: 'POST',
            headers: getHeaders(),
            body: JSON.stringify(data)
        });
        return res.json();
    },
    updateProduct: async (id, data) => {
        const res = await fetch(`${API_URL}/products/${id}`, {
            method: 'PUT',
            headers: getHeaders(),
            body: JSON.stringify(data)
        });
        return res.json();
    },
    deleteProduct: async (id) => {
        // Since we didn't add delete routes to backend initially, we might need to handle this.
        // For now, assume backend has DELETE /api/products/:id
        const res = await fetch(`${API_URL}/products/${id}`, {
            method: 'DELETE',
            headers: getHeaders()
        });
        return res.json();
    },

    // Categories
    getCategories: async () => {
        const res = await fetch(`${API_URL}/categories`);
        if (!res.ok) return [];
        return res.json();
    },
    addCategory: async (data) => {
        const res = await fetch(`${API_URL}/categories`, {
            method: 'POST',
            headers: getHeaders(),
            body: JSON.stringify(data)
        });
        return res.json();
    },
    updateCategory: async (id, data) => {
        const res = await fetch(`${API_URL}/categories/${id}`, {
            method: 'PUT',
            headers: getHeaders(),
            body: JSON.stringify(data)
        });
        return res.json();
    },
    deleteCategory: async (id) => {
        const res = await fetch(`${API_URL}/categories/${id}`, {
            method: 'DELETE',
            headers: getHeaders()
        });
        return res.json();
    },

    // Gallery
    getGallery: async () => {
        const res = await fetch(`${API_URL}/gallery`);
        return res.json();
    },
    addGallery: async (data) => {
        const res = await fetch(`${API_URL}/gallery`, {
            method: 'POST',
            headers: getHeaders(),
            body: JSON.stringify(data)
        });
        return res.json();
    },
    updateGallery: async (id, data) => {
        const res = await fetch(`${API_URL}/gallery/${id}`, {
            method: 'PUT',
            headers: getHeaders(),
            body: JSON.stringify(data)
        });
        return res.json();
    },
    deleteGallery: async (id) => {
        const res = await fetch(`${API_URL}/gallery/${id}`, {
            method: 'DELETE',
            headers: getHeaders()
        });
        return res.json();
    },

    // Brochures
    getBrochures: async () => {
        const res = await fetch(`${API_URL}/brochures`);
        return res.json();
    },
    addBrochure: async (formData) => {
        const token = sessionStorage.getItem('ndtools_token');
        const res = await fetch(`${API_URL}/brochures`, {
            method: 'POST',
            headers: {
                ...(token ? { Authorization: `Bearer ${token}` } : {})
            },
            body: formData
        });
        return res.json();
    },
    updateBrochure: async (id, formData) => {
        const token = sessionStorage.getItem('ndtools_token');
        const res = await fetch(`${API_URL}/brochures/${id}`, {
            method: 'PUT',
            headers: {
                ...(token ? { Authorization: `Bearer ${token}` } : {})
            },
            body: formData
        });
        return res.json();
    },
    deleteBrochure: async (id) => {
        const res = await fetch(`${API_URL}/brochures/${id}`, {
            method: 'DELETE',
            headers: getHeaders()
        });
        return res.json();
    }
};
